import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=af5db5ca&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=af5db5ca&prod&lang=scss&scoped=true"
import style1 from "./Button.vue?vue&type=style&index=1&id=af5db5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5db5ca",
  null
  
)

export default component.exports